import { UploadOutlined } from "@ant-design/icons";
import { Button, Col, Form, Input, Modal, Radio, Row, Select, Upload } from "antd";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { normFile } from "utils/index";

export default function ModalCreated({
  openModal,
  onCancel,
  onSubmit,
  shops,
  loading,
  selected,
}) {
  const [form] = Form.useForm();
  const type = Form.useWatch('type', form);
  const { t } = useTranslation()

  useEffect(() => {
    if (!openModal) {
      form.resetFields();
    }

    else if (openModal && selected) {
      form.setFieldsValue({
        toUser: selected.toUser.map(user => user.user.shops[0].shop.shop_code),
        content: selected.content.find(content => content.lang === 'de').text,
        attachments: selected?.attachments ? selected.attachments.map((attachment, index) => ({
          uid: attachment._id,
          name: 'File ' + (index + 1),
          status: 'done',
          url: attachment.url,
          isOld: true,
        })) : [],
      });
    }
  }, [openModal]);

  return (
    <Modal
      title={t('sendNotification')}
      centered
      open={openModal}
      footer={null}
      onCancel={onCancel}
      width={768}
      destroyOnClose
    >
      <Form form={form} layout="vertical" onFinish={onSubmit}>
        {
          !selected &&
          <Form.Item
            name="type"
            label={t('sendTo')}
            required
            rules={[
              {
                required: true,
              },
            ]}
          >
            <Radio.Group>
              <Radio value="0">{t('shopAssign')}</Radio>
              <Radio value="1">{t('allShop')}</Radio>
            </Radio.Group>
          </Form.Item>
        }
        {
          (type == 0 || selected) && 
          <Form.Item
            name="toUser"
            label={t('shopAssign')}
            required
            rules={[
              {
                required: true,
              },
            ]}
          >
            <Select
              disabled={selected}
              size="large"
              mode="multiple"
              allowClear
              style={{
                width: '100%',
              }}
              placeholder=""
              options={shops.map(shop => ({
                label: shop.shops[0].shop.shop_code,
                value: shop.shops[0].shop.shop_code,
              }))}
            />
          </Form.Item>
        }
        <Form.Item
          name="content"
          label={t('content')}
          required
          rules={[
            {
              required: true,
            },
          ]}
        >
          <Input.TextArea rows={4} />
        </Form.Item>
        <Form.Item
          name="attachments"
          label={t('attachments')}
          valuePropName="fileList"
          getValueFromEvent={normFile}
        >
          <Upload
            name="logo">
            <Button icon={<UploadOutlined />}>{t('upload')}</Button>
          </Upload>
        </Form.Item>
        <Row gutter={16}>
          <Col span={4} offset={8}>
            <Form.Item>
              <Button loading={loading} style={{ width: "100%" }} htmlType="submit">
                Ok
              </Button>
            </Form.Item>
          </Col>
          <Col span={4}>
            <Button loading={loading} style={{ width: "100%" }} onClick={onCancel}>
              {t('cancel')}
            </Button>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
}
